export default __webpack_public_path__ + "static/media/ic_back.082dd6ea.svg";